import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { RequiredValidator } from '../../../ui/gzForm/validators/required.validator';
import { MinLengthValidator } from '../../../ui/gzForm/validators/min-length.validator';
import { EditIntegrationConstants } from '../EditIntegrationConstants';
import { MaxLengthValidator } from '../../../ui/gzForm/validators/max-length.validator';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { IntegrationRequirementsWebComponent } from '../../integrationRequirements';
import { BaseSensorWebComponent } from '../../sensors/base/BaseSensorWebComponent';
import { GzFormFieldWebComponent } from '../../../ui/gzForm/formField';

export class EditIntegrationWebView extends BaseWebComponentView {
  public initiated = false;

  public dom: {
    $wrapper: HTMLElement;
    $integrationRequirements: IntegrationRequirementsWebComponent;
    $testConnectivityButton: GzButtonWebComponent;
    $confirmedRequirementsButton: GzButtonWebComponent;
    $integrationName: GzFormFieldWebComponent;
    $companyName: HTMLElement;
    $sensorArea: HTMLElement;
    $sensors: BaseSensorWebComponent[];
  };

  getDomElements(): void {
    this.dom = {
      $wrapper: this.shadow.querySelector('.form-wrapper'),
      $integrationRequirements: this.shadow.querySelector('#integration_requirements'),
      $testConnectivityButton: this.shadow.querySelector('#test_connectivity'),
      $confirmedRequirementsButton: this.shadow.querySelector('#confirmed_requirements_button'),
      $integrationName: this.shadow.querySelector('#integration_name'),
      $companyName: this.shadow.querySelector('#company_name'),
      $sensorArea: this.shadow.querySelector('#sensors_area'),
      $sensors: [],
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations(): any {
    this.translations = this.stringsTranslator.getSensorsIntegrationsStrings();
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    return this.translations;
  }

  public translateSensorConnectivityErrorCodes(errorCode: number): string {
    return this.stringsTranslator.translateSensorConnectivityErrorCodes(errorCode);
  }

  public translateAddSensorTooltipMessage(integrationType: number): string {
    return this.stringsTranslator.translateAddSensorTooltipMessage(integrationType);
  }

  setTranslatedStrings(): void {
    this.dom.$integrationName.label = this.dependencies.translateFn('Sensor name');
    this.dom.$testConnectivityButton.innerText = this.dependencies.translateFn('Test connectivity');
    this.dom.$confirmedRequirementsButton.innerText = this.dependencies.translateFn('Requirements');
  }

  buildView(): void {
    this.buildSuccessView();
  }

  buildSuccessView(): void {
    this.dom.$integrationName.Validators = [
      RequiredValidator(this.commonStrings.requiredField),
      MinLengthValidator(
        EditIntegrationConstants.Name.MinLength,
        this.dependencies.translateFn('The name must have minimum {integrationNameMinLength} characters.', {
          integrationNameMinLength: EditIntegrationConstants.Name.MinLength,
        })
      ),
      MaxLengthValidator(
        EditIntegrationConstants.Name.MaxLength,
        this.dependencies.translateFn('The name must have maximum {integrationNameMaxLength} characters.', {
          integrationNameMaxLength: EditIntegrationConstants.Name.MaxLength,
        })
      ),
    ];
    this.dom.$testConnectivityButton.disabled = true;
    this.initForm();
  }

  public initForm(): void {
    this.resetData();
    this.dom.$testConnectivityButton.disabled = true;
  }

  public resetData(): void {
    this.dom.$integrationName.value = '';
    this.dom.$integrationName.resetField();
    this.dom.$sensors.forEach(sensor => {
      sensor.resetData();
    });
  }

  public setIntegrationViewData(integration): void {
    this.dom.$integrationName.value = integration.name;
    this.dom.$integrationName.resetField();
  }
}
